import { apiClient } from './authService';
import { buildDownloadUrl } from './downloadUrl';

const toFormData = ({ file, displayName, workspaceId, pipelineSessionId }) => {
  if (!file) {
    throw new Error('2D export requires an input file.');
  }

  const formData = new FormData();
  formData.append('file', file);

  if (displayName) {
    formData.append('display_name', displayName);
  }
  if (workspaceId) {
    formData.append('workspace_id', workspaceId);
  }

  if (pipelineSessionId) {
    formData.append('pipeline_session_id', pipelineSessionId);
  }

  return formData;
};

export const twodService = {
  async export({ file, displayName, workspaceId = null, pipelineSessionId = null }) {
    const formData = toFormData({ file, displayName, workspaceId, pipelineSessionId });

    const response = await apiClient.post('/twod/export', formData);

    return response.data;
  },

  async listUserExports() {
    const response = await apiClient.get('/twod/files/user');
    return response.data;
  },

  async downloadExport(jobId) {
    const response = await apiClient.get(
      `/twod/job/${encodeURIComponent(jobId)}/download`,
      { responseType: 'blob' }
    );
    return response.data;
  },

  buildDownloadUrl(jobId) {
    if (!jobId) return null;
    return buildDownloadUrl(`/twod/job/${encodeURIComponent(jobId)}/download`);
  },
};

export default twodService;
